import React from "react";
import { FOOTER } from "../../../layout/eng/footer";
import { SUBHEADER } from "../../../layout/eng/subheader";
import { EN_Products } from "../../../parts/eng/business/products";
import { Helmet } from "react-helmet";
export const EN_PRODUCTS = () => {
  return (
    <main id="content">
      <SUBHEADER />
      <div id="business">
        <EN_Products />
      </div>
      <FOOTER />
    </main>
  );
};
